import React from 'react';
import { BorderRadiusTokens, ButtonTypeTokens, ColorTokens, IconTokens, SizeTypeTokens, StackJustifyContent, StackType, TypographyTypeTokens, } from '@voltmoney/schema';
import Card from '../card/Card';
import Stack from '../stack/Stack';
import Typography from '../typography/Typography';
import Button from '../button/Button';
import Space from '../space/Space';
const IcebreakerCard = ({ title, subtitle, onPress, ctaText, gradient, bgColor = ColorTokens.Grey_600, action, triggerAction, }) => {
    if (!title)
        return React.createElement(React.Fragment, null);
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(Card, { gradient: gradient, bgColor: bgColor, borderRadius: BorderRadiusTokens.BR2, padding: {
            vertical: SizeTypeTokens.XL,
            horizontal: SizeTypeTokens.MD,
        }, header: {
            children: (React.createElement(Stack, null,
                React.createElement(Typography, { label: title, type: TypographyTypeTokens.S6, color: ColorTokens.Grey_200 }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(Typography, { label: subtitle }),
                React.createElement(Space, { size: ctaText
                        ? SizeTypeTokens.MD
                        : SizeTypeTokens.NONE }))),
        }, footer: {
            children: ctaText ? (React.createElement(Stack, { type: StackType.row, justifyContent: StackJustifyContent.flexEnd },
                React.createElement(Button, { type: ButtonTypeTokens.SmallOutline, icon: { name: IconTokens.Chat }, labelColor: ColorTokens.Grey_50, label: ctaText, onPress: handleAction }))) : (React.createElement(React.Fragment, null)),
        } }));
};
export default React.memo(IcebreakerCard);
export { IcebreakerCard };
